import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import React from "react";
import { connect } from "react-redux";
import Racuni from "./Table";
import IzdavanjeRacuna from "./IzdavanjeRacuna.js";
import Search from "./Search";
import "./tabs.scss";

export class TabContainer extends React.Component {
  render() {
    return (
      <div className="racuniTabs">
        <Tabs>
          <TabList>
            <Tab>Lista</Tab>
            <Tab>Izdavanje Računa</Tab>
          </TabList>
          <hr
            style={{
              padding: "0px",
              margin: "0px",
              border: "1px solid #808080",
            }}
          />
          <TabPanel>
            <Search />
            <Racuni invoices={this.props.invoices} />
          </TabPanel>

          <TabPanel>
            <IzdavanjeRacuna />
          </TabPanel>
        </Tabs>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userLoggedIn: state.client.userLoggedIn,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    mapState: (type, data) => dispatch({ type: type, data: data }),
    API: (type, data) => dispatch({ type: type, data: data }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TabContainer);
